import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import { GetServerSidePropsContext } from 'next';
import { getInternationalizedStaticUrls } from 'utils/getInternationalizedStaticUrls';

const RETURN_URL_COOKIE_NAME = 'returnUrl';

export const setReturnUrlCookie = (context: GetServerSidePropsContext, returnUrl: string): void => {
    setCookie(RETURN_URL_COOKIE_NAME, returnUrl, {
        req: context.req,
        res: context.res,
        maxAge: 60 * 15,
        path: '/',
        sameSite: 'lax',
        httpOnly: false,
    });
};

export const getReturnUrlCookie = (context: GetServerSidePropsContext): string | null => {
    const returnUrl = getCookie(RETURN_URL_COOKIE_NAME, { req: context.req, res: context.res });

    return typeof returnUrl === 'string' ? returnUrl : null;
};

export const deleteReturnUrlCookie = (context?: GetServerSidePropsContext): void => {
    if (context) {
        deleteCookie(RETURN_URL_COOKIE_NAME, {
            req: context.req,
            res: context.res,
            path: '/',
        });
    } else {
        deleteCookie(RETURN_URL_COOKIE_NAME, {
            path: '/',
        });
    }
};

export const validateReturnUrl = (returnUrl: string | null, domainUrl: string): string | null => {
    if (!returnUrl) {
        return null;
    }

    if (!returnUrl.startsWith('/') || returnUrl.startsWith('//')) {
        return null;
    }

    const pathname = returnUrl.split('?')[0];

    const loginUrls = getInternationalizedStaticUrls(
        ['/b2b-login', '/login', '/b2b-reset-password', '/b2b-recover-password'],
        domainUrl,
    );

    if (loginUrls.some((loginUrl) => pathname === loginUrl)) {
        return null;
    }

    return returnUrl;
};
